<script setup lang="ts">
import { plainToClass } from "class-transformer";
import { News } from "@/models/news";

const route = useRoute();

if (!route.params.id) {
  console.log("Warning! Make sure user is authenticated!");
}

const { press_release: newsJson } = await apiFetch(
  `/press_releases/${route.params.id}`,
);
const news = plainToClass(News, newsJson);

definePageMeta({
  layout: "default",
});

useHead({
  title: news.title,
  meta: [
    { name: "description", content: news.body },
    { name: "og:title", content: news.title },
    { name: "og:description", content: news.body },
    { name: "twitter:title", content: news.title },
  ],
});
</script>

<template lang="pug">
v-container
  v-row(align="center" justify="center")
    v-col(cols="12" md="8").text-center
      img(:src="news.image.url")
  v-row(align="center" justify="center")
    v-col(cols="12" md="8").text-center
      h3 {{ news.title }}
  v-row.news
    v-col(cols="12" md="10" class="date" class="text-right") {{ news.disp_published_at }}
  v-row.news(align="center" justify="center")
    v-col(cols="12" md="8")
      div(v-html="news.parsed_body")


</template>

<style lang="scss" scoped>
.v-container {
  margin-bottom: 50px;
  img {
    width: 100%;
    height: 400px;
    object-fit: cover;
  }
}

.news {
  line-height: 2rem;
}

@media (max-width: 576px) {
  .v-container {
    img {
      height: 200px;
    }
  }
}
</style>
